/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EncryptionService } from '../../service/encryption.service';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { apiUrls } from '../constants/apiUrls.const';
import { AuthService } from '../../service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SetInterceptor implements HttpInterceptor {
  encryptedString: any;
  private _encryptionService = inject(EncryptionService);
  private _translateService = inject(TranslateService);
  private _authService = inject(AuthService);

  getTokenForRequest(): string | null {
    return this._encryptionService.decryptLocalStorage(environment.storageKey);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }

  handleRequest(req: HttpRequest<any>) {  
    let token: string | null = null;
    let authorizationHeader = '';
    if (req.url.includes(apiUrls.resetPassword)  && req.body && req.body.isResetPassword) {
      const resetToken = this._authService.resetTokenSignal();
      
      if (resetToken) {
        authorizationHeader = resetToken;
      }
    } else {      
      const storageKey = localStorage.getItem(environment.storageKey);
      token = storageKey ? storageKey : null;
      authorizationHeader = token ? `Bearer ${token}` : '';
    }

    const headers = {
      authorization: authorizationHeader,
      appkey: Math.floor(Date.now()).toString(),
      'x-portal': 'web',
    };

    const isFormData = req.body instanceof FormData;
    const newHeaders: Record<string, string> = {
      
      
      hash: this._encryptionService.encryptData(headers),
      deviceType: 'webapp',
      'x-portal': 'web',
      language: this._translateService.currentLang || '',
      appkey: Math.floor(Date.now()).toString(), 
    };

    if (!isFormData) {
      newHeaders['Content-Type'] = 'application/json';
    }

    let clonedReq = req.clone({
      headers: new HttpHeaders(newHeaders),
    });

    if (
      !isFormData &&
      (req.method.toLowerCase() === 'post' || req.method.toLowerCase() === 'put')
    ) {
      console.log(clonedReq, 'kkkkkkkkkkkk');
       
      clonedReq = clonedReq.clone({
        body: {
          hash: this._encryptionService.encryptData(req.body),
        },
      });
    }

    return clonedReq;
  }
}


